import Highlighter from "react-highlight-words";
import { useDispatch, useSelector } from "react-redux";
import { getloanAdvanceData } from "../../../../store/Api";
import { useEffect } from "react";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useState } from "react";
// import EmployeeDetails from "./employeeDetails";
import React from "react";
import nodeinstance from "../../../../nodeInstance";
import { GoCircle } from "react-icons/go";
import PaymentPopup from "./invoice_payment";
import { BsCloudDownload } from "react-icons/bs";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import { setAppError } from "../../../../store/userSlice";
// import EmployeeManager from "./employeemanager";

export default function InvoiceCostPlusSubModule({
  propData,
  setInvoiceNumber,
  setCancel,
}) {
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const navigate = useNavigate();

  const [searchWords, setSearchWords] = useState([]);

  const row = [
    {
      id: 1,
      name: "YTC",
    },
  ];
  const rowsData = [
    {
      id: 1,
      name: "YTC",
    },
    {
      id: 2,
      name: "YTC",
    },
    {
      id: 3,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
    {
      id: 4,
      name: "YTC",
    },
  ];
  const tableHeading = [
    {
      rate_category_id: 1,
      title: "EMPLOYEE SALARY PACKAGE",
      bgPrimary: "bg-gray",
      bgSecondary: "bg-gray",
    },
  ];

  const tableProperties = {
    colWidth: "w-56",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };
  const tableProperties2 = {
    colWidth: "w-28",
    colHeight: "h-[2rem]",
    itemHeight: "h-[3rem]",
  };

  console.log("Data to be seen here....fgfh....", propData);
  const [clientValue, setClientValue] = useState();
  const handleClientChange = (event) => {
    setClientValue(event.target.value);
  };
  console.log("data ..........", clientValue);
  const [paymentPopUp, setPaymentPopUp] = useState(false);
  const [invoiceData, setInvoiceData] = useState();

  const InvoiceData = async () => {
    try {
      const response = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/summary/${clientValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        console.log("client invoice data....", response);
        setInvoiceData(response?.data?.data);
      }
    } catch (error) {
      console.log("error........", error);
    }
  };
  console.log("edffyegfdytyfyddytcyyd", clientValue);
  useEffect(() => {
    InvoiceData();
    return;
  }, [clientValue, paymentPopUp]);
  console.log("invoiceData", invoiceData?.length);

  const [propId, setPropId] = useState();

  const handleInvoiceClick = (id) => {
    setPropId(id);
    setPaymentPopUp(true);
  };

  const handleEditClick = (id, name) => {
    navigate("/dashboard/invoice-cost-plus/Edit-invoice-batch");
    setInvoiceNumber(id);
    setCancel(name);
  };
  const [downloadLoading, setDownloading] = useState(false);

  const downloadFile = async () => {
    // setDownloading(true)
    console.log("clientValue......", clientValue);
    if (
      clientValue === null ||
      clientValue === undefined ||
      clientValue === ""
    ) {
      dispatch(
        setAppError({
          msg: "Client value is required",
        })
      );
      setDownloading(false);
      return;
    }
    try {
      const response = await nodeinstance.get(
        `/dashboard/invoiceCostPlus/downloadempSummaryExcel/${clientValue}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Visa cost sec deposite summary report`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
      }
    } catch (error) {
      console.log("error to be displayed here.......", error);
      setDownloading(false);
      dispatch(
        setAppError({
          msg: "Falied to download the summary excel",
        })
      );
    }
  };
  return (
    <>
      <div className="pt-2 uppercase m-3">
        {/* <div className="flex flex-wrap  gap-2 w-full items-center "> */}
        <div className="flex flex-wrap gap-2 justify-betweem mb-1 items-center">
          <div className="flex gap-2 ml-auto">
            <select
              className="border-[1px] border-border dark:bg-dark rounded-md h-10 p-1 mt-4 text-xs w-48"
              onChange={handleClientChange}
            >
              <option>{"SELECT CLIENT VALUE"}</option>
              {propData.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.client_id}>{data.client_name}</option>
                </React.Fragment>
              ))}
            </select>

            {/* <Search
            keywords={[
              "project_incharge",
              "flight_details",
              "country",
              "arrival_sector",
              "pickup_to_be_arranged",
            ]}
            setSearchWords={setSearchWords}
            className="text-lg p-3"
          /> */}
            <button
              className="p-1 px-2 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2 h-10 p-3 mt-4 "
              onClick={() => downloadFile()}
              disabled={downloadLoading}
            >
              <p>Download</p>
              {/* {downloadLoading && <CgSpinner className="animate-spin" />} */}
            </button>
          </div>
          <div
            className="flex flex-col w-full gap-1 my-2 overflow-x-scroll pt-2"
            // style={summaryData?.data?.length > 4 ? { height: "250px" } : {}}
          >
            <div className="flex">
              {row.map((section, sectionIndex) => (
                <div className="flex flex-col relative" key={sectionIndex}>
                  {sectionIndex == 0 && (
                    <>
                      <div className={`flex w-full gap-1 `}>
                        <>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            S.NO.
                          </h3>

                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            CLIENT NAME
                          </h3>

                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            INVOICE NO/REQUEST NO
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            INVOICE AMOUNT{" "}
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            INVOICE SENT DATE
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            AMOUNT RECEIVED
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            CREDIT NOTE
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            BALANCE AMOUNT
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            AMOUNT RECEIVED SPLIT
                          </h3>
                          <h3
                            className={`flex justify-center items-center text-sm ${tableHeading[sectionIndex].bgSecondary} ${tableProperties.colWidth} ${tableProperties.itemHeight}`}
                          >
                            EDIT BATCH
                          </h3>
                        </>
                      </div>
                    </>
                  )}
                  {invoiceData?.length <= 0 ? (
                    <div className="flex items-center justify-center w-full h-full m-4">
                      <div className="flex flex-col items-center gap-1 relative">
                        <h2>No Data found</h2>
                      </div>
                    </div>
                  ) : (
                    <div className="mb-2">
                      {invoiceData?.map((data, index) => (
                        <div
                          className="flex w-full gap-1 relative mb-2 mt-2"
                          key={index}
                        >
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {index + 1}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {data.client}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {data.invoice_no}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {data.invoice_amount}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {/* {data.invoice_sent_date} */}
                            {data.invoice_sent_date
                              ? new Date(data.invoice_sent_date)
                                  .toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "short",
                                    year: "numeric",
                                  })
                                  .split(" ")
                                  .join("-")
                                  .toUpperCase()
                              : "------"}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {data.amount_received ? data.amount_received : 0}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {data.credit_note ? data.credit_note : 0}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {parseInt(data.invoice_amount) -
                              (parseInt(
                                data.credit_note === null ? 0 : data.credit_note
                              ) +
                                parseInt(
                                  data.amount_received === null
                                    ? 0
                                    : data.amount_received
                                ))}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            {data.amount_received_split
                              ? data.amount_received_split
                              : "--------"}
                          </p>
                          <p
                            className={`bg-slate-200 flex items-center justify-center ${tableProperties.colWidth} ${tableProperties.colHeight}`}
                          >
                            <div>
                              <button
                                className="rounded-md bg-white p-1.5 text-sm text-black border border-gray-400 mr-3 ml-4"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.2rem",
                                }}
                                onClick={() => {
                                  handleInvoiceClick(data);
                                }}
                                disabled={
                                  data.amount_received_split === "CANCELLED" ||
                                  parseInt(data.invoice_amount) -
                                    (parseInt(
                                      data.credit_note === null
                                        ? 0
                                        : data.credit_note
                                    ) +
                                      parseInt(
                                        data.amount_received === null
                                          ? 0
                                          : data.amount_received
                                      )) ===
                                    0
                                }
                              >
                                <BsCloudDownload size={"1rem"} />
                              </button>
                              <button
                                className="rounded-md bg-white p-1.5 text-sm text-black border border-gray-400 mr-3 ml-4"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "1.2rem",
                                }}
                                onClick={() => {
                                  handleEditClick(
                                    data.invoice_no,
                                    data.amount_received_split
                                  );
                                }}
                              >
                                <CiEdit size={"1rem"} />
                              </button>
                            </div>
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        {paymentPopUp ? (
          <PaymentPopup
            setShowPromptElement={setPaymentPopUp}
            showPromptElement={paymentPopUp}
            propData={propId}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
